<div class="text-center pt-5">
  <h1>Missing Resource!</h1>
  <div class="w-100">
    <span class="badge bg-warning text-dark">404</span>
  </div>
  <a [routerLink]="['/']">Return home</a>
</div>
